// extracted by mini-css-extract-plugin
module.exports = {"Input":"Input_Input__1fbVC","Label":"Input_Label__1JeoN","InputElement":"Input_InputElement__3u0HR","Invalid":"Input_Invalid__1Dtfs"};